import { Header, PriceCard } from '../../components';
import './price.page.css';

const Pricing = () => {
    return (
        <div>
            <Header title="Pricing" shadow="true"></Header>
            <div className="page-section">
                <div className="container">
                    <div className="price-container">
                        <h2>Anti-wrinkle Injections</h2>
                        <ul>
                            <li>Areas of upper face anti-wrinkle injections (botox) administered by Dr Kathryn.</li>
                            <li>Areas to choose from: forehead, frown, crow’s feet, arch lift/botox brow lift, bunny lines, jelly roll (lower eye lid). </li>
                            <li>Minimum age 21 years.</li>
                            <li>£30 supplement per area for men as stronger muscles & more botulinum toxin required. </li>
                        </ul>
                        <div className="card-grid-2">
                            <PriceCard
                                title="1 area"
                                price="£175">
                            </PriceCard>
                            <PriceCard
                                title="2 areas"
                                price="£225">
                            </PriceCard>
                            <PriceCard
                                title="3 areas"
                                price="£265">
                            </PriceCard>
                            <PriceCard
                                title="4 areas"
                                price="from £305">
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Advanced anti-wrinkle Injection Treatments</h2>
                        <div className="card-grid-2">
                            <PriceCard
                                title="Lip Flip"
                                price="£99"
                                infos={[
                                    'Lip Flip with Dr Kathryn Hazlehurst using  Botulinum toxin injections to give the upper lip a fuller appearance.',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Gummy smile correction"
                                price="£190"
                                infos={[
                                    'Gummy smile correction with Botulinum toxin injections administered by Dr Hazlehurst.',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Jawline slimming"
                                price="£310"
                                infos={[
                                    'Facial jawline / masseter slimming with botulinum toxin injections.',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Neck Lift and vertical bands treatment"
                                price="£310"
                                infos={[
                                    'Nefertiti neck lift. Anti-wrinkle injections to the neck area with Dr Hazlehurst to lift the neck and give the neck a smoother more youthful appearance by smoothing the vertical lines (platysmal bands).',]}>
                            </PriceCard>
                            <PriceCard
                                title="Armpit for Anti-sweating 'botox'"
                                price="£390"
                                infos={[
                                    'Cosmetic anti-sweating. ‘Botox’ injections to the armpits to reduce sweating administered by Dr Hazlehurst. Lasts up to 6 months.',
                                    ]}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Dermal Fillers</h2>

                        <div className="card-grid-2">
                            <PriceCard
                                title="Lip enhancement with lip filler"
                                price="£265"
                                infos={[
                                    'Lip filler injected for lip rejuvenation and enlargement. ']}>
                            </PriceCard>
                            <PriceCard
                                title="Dermal fillers nasolabial folds (nose to mouth)"
                                price="£295 for 1ml"
                                infos={[
                                    'Dermal filler injected into the nasolabial folds (nose to mouth areas)']}>
                            </PriceCard>
                            <PriceCard
                                title="Dermal fillers marionette Lines (mouth to chin)"
                                price="£295 for 1ml"
                                infos={[
                                    'Dermal fillers to the marionette lines (mouth to chin).']}>
                            </PriceCard>
                            <PriceCard
                                title="Dermal filler for smokers lines. Above lip lines."
                                price="£265"
                                infos={[
                                    'Dermal filler Injections for smokers lines. Vertical lines above upper lip.',]}>
                            </PriceCard>
                            <PriceCard
                                title="Cheek enhancement with dermal filler"
                                price="£310 for 1ml"
                                infos={[
                                    'Sculpt, enhance and replace volume.',
                                    'Fill hollow areas and add definition. Lifting the face.',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Jawline enhancement with dermal filler"
                                price="from £310"
                                infos={[
                                    'Define and enhance the jawline with dermal filler.',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Chin enhancement with dermal filler"
                                price="£310 for 1ml"
                                infos={[
                                    'Chin enhancement with dermal filler.',
                                    'Add definition, reshape, improve facial profile',
                                    ]}>
                            </PriceCard>
                            <PriceCard
                                title="Tear trough filler"
                                price="£420"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Temple hollows filler"
                                price="From £420"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Forehead filler"
                                price="£POA"
                                infos={[]}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Fat Dissolving Injections</h2>
                        <div className="card-grid">
                        <PriceCard
                                title="Fat Dissolving Injections"
                                price="from £300"
                                infos={['areas: stomach, hips, chin, jowls, under arms']}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Microneedling</h2>
                        <div className="card-grid">
                            <PriceCard
                                title="Microneedling medical grade face and neck with mesotherapy application"
                                price="£160"
                                infos={[]}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Chemical skin peels </h2>

                        <div className="card-grid">
                            <PriceCard
                                title="CLINICARE Chemical skin peel"
                                price="£85"
                                infos={[
                                    '(Glow, refresh or pure peel)']}>
                            </PriceCard>
                            <PriceCard
                                title="Obagi blue radiance peel"
                                price="£105"
                                infos={[
                                    '']}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Aesthetic consultation</h2>

                        <div className="card-grid">
                            <PriceCard
                                title="Aesthetic Consultation with Dr Kathryn"
                                price="£50"
                                infos={[
                                    'Aesthetic consultation with Dr Kathryn to discuss your aesthetic needs. The cost of this consultation will be deducted from your treatment with Dr Kathryn. ']}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>

                    <div className="price-container">
                        <h2>Skin Boosters</h2>
                        <div className="card-grid-2">
                          
                            <PriceCard
                                title="Profhilo"
                                price="£270 per 2ml syringe"
                                infos={['Areas that can be treated: 5 Point face lift / BAP technique Neck',
                                '- Course of 2 Profhilo 2 x 2ml, 4 weeks apart £490',
                                '- Face and neck Profhilo 2 x 2ml syringe £490']}>
                            </PriceCard>
                            <PriceCard
                                title="Hydromax"
                                price="£260 per syringe"
                                infos={['Areas that can be treated:', 'Cheeks', 'Accordion lines','Neck','Chest']}>
                            </PriceCard>
                            <PriceCard
                                title="Seventy hyal skin boosters"
                                price="£190 per 2ml syringe"
                                infos={['Areas that can be treated:','5 Point face lift / BAP technique',  'Neck', 'Chest', 'Hand rejuvenation']}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Polynucleotides</h2>
                        <div className="card-grid">
                            <PriceCard
                                title="Polynucleotides"
                                price="£290 per 2ml syringe"
                                infos={['Areas that can be treated:','Under eye / around eyes','Face', 'Neck','Chest', 'Knees','Package £699 for 3 x 2ml syringe']}>
                            </PriceCard>
                        </div>
                    </div>
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Microsclerotherapy </h2>
                        <div className="card-grid">
                            <PriceCard
                                title="Microsclerotherapy "
                                price="£300"
                                infos={["Injection of sclerosant into leg thread veins.","The initial consultation fee is £50 which is deductible from the cost of the treatment"]}>
                            </PriceCard>
                        </div>
                    </div>

                  
                    <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Skin Lesions</h2>
                        <p>Minimum Age 18</p>

                        <div className="card-grid-2">
                            <PriceCard
                                title="2 Lesion Removals"
                                price="£140"
                                infos={[
                                    '2 lesion removal for skin tag / spider naevus / campbell de morgan / milia / 1 small patch of facial thread veins / xanthelasma / sebaceous hyperplasia / dermatosis papulosa nigra.',
                                    'Including patch test & consultation.']}>
                            </PriceCard>
                            <PriceCard
                                title="Follow up treatments for one lesion."
                                price="£80"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Additional lesions"
                                price="£80"
                                infos={[
                                    'Per skin tag depending on size and amount']}>
                            </PriceCard>
                            <PriceCard
                                title="Full face"
                                price="£340"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Full neck"
                                price="£340"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Half back"
                                price="£340"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Both Armpits"
                                price="£340"
                                infos={[]}>
                            </PriceCard>
                            <PriceCard
                                title="Cryotherapy"
                                price="from £100"
                                infos={["Wart removal £100", "Verruca £100","Seborrheic Keratosis £150","Benign pigment patch £100", "Follow up treatment at 4 weeks £50.00"]}>
                            </PriceCard>
                        </div>
                    </div>
                      <div className="spacer-2"></div>
                    <div className="price-container">
                        <h2>Package Offers</h2>

                        <div className="card-grid-2">
                            <PriceCard
                                title="2 x 2ml syringes of Profhilo "
                                price="£490"
                                infos={['(Discount of £50)']}>
                            </PriceCard>
                            <PriceCard
                                title="Polynucleotides"
                                price="£699"
                                infos={['3 x 2ml syringe','(Discount of £171)']}>
                            </PriceCard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default Pricing;